import { render, staticRenderFns } from "./PdpTilesForColor.vue?vue&type=template&id=005a4cda&scoped=true&"
import script from "./PdpTilesForColor.vue?vue&type=script&lang=js&"
export * from "./PdpTilesForColor.vue?vue&type=script&lang=js&"
import style0 from "./PdpTilesForColor.vue?vue&type=style&index=0&id=005a4cda&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005a4cda",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppButton: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppButton.vue').default})
